import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { Link } from "react-router-dom";
import Searchbox from '../searchbox/Searchbox'


import Sidebar from './sidebar'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
}));



// window.onload = count;
export default function DenseAppBar() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="fixed" style={{ backgroundColor: '#10ac84' }}>
        <Toolbar variant="dense">
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <Sidebar />
          </IconButton>
          <Link to="/" id='lnk'>
            <Typography id='navname' variant="h6" color="inherit" style={{ marginLeft: '-40px',fontWeight: '600', color: 'white' }}>
              ViewNotes 
            </Typography>
          </Link>
<Searchbox/>
        </Toolbar>

      </AppBar>
    </div>
  );
}
